<template>
  <div id="app" class="container-fluid">
    <!-- Header (UNCHANGED) -->
    <full_ent_head :visit_id="visit_id" />

    <!-- Main Content -->
    <div class="main-content">
      <div class="card diagnoses-card">
        <div class="card-header diagnoses-header">
          <div>
            <h3 class="mb-1">
              <i class="fas fa-stethoscope"></i>
              Diagnoses
            </h3>
            <small class="text-muted">
              Recorded ent diagnoses for this patient
            </small>
          </div>

          <button class="btn btn-primary" @click="showAddDiagnosisModal">
            <i class="fas fa-plus"></i> Add Diagnosis
          </button>
        </div>

        <div class="card-body">
          <div class="table-responsive">
            <table class="table diagnoses-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Diagnosis</th>
                  <th>Type</th>
                  <th>Stage</th>
                  <th class="text-end">Actions</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(diag, index) in diagnoses" :key="diag.id">
                  <th>{{ index + 1 }}</th>
                  <td>{{ diag.diagnosis }}</td>
                  <td>{{ diag.diagnosis_type }}</td>
                  <td>{{ diag.diagnosis_stage }}</td>
                  <td class="text-end">
                    <button
                      class="btn btn-sm btn-danger button-touch"
                      @click="deleteDiagnosis(diag.id)"
                    >
                      Delete
                    </button>
                    <!-- <button
                class="btn btn-sm btn-info button-touch"
                @click="viewDiagnosis(diag)"
              >
                View
              </button> -->
                  </td>
                </tr>
                <tr v-if="diagnoses.length === 0">
                  <td colspan="6" class="text-center text-muted py-4">
                    No diagnoses recorded for this patient
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <AddDiagnosisModal
    v-if="showAddDiagnosis"
    :visit_id="visit_id"
    @close-add-diagnosis-modal="closeDiagMod"
    @refresh-diagnoses="fetchDiagnoses"
  />
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import AddDiagnosisModal from "../../visits_management/diagnosis/AddDiagnosisModal.vue";
import full_ent_head from "./full_ent_head.vue";

export default {
  name: "PatientDiagnoses",
  components: {
    full_ent_head,
    AddDiagnosisModal,
  },
  data() {
    return {
      visit_id: this.$route.params.visit_id,
      diagnoses: [],
      showAddDiagnosis: false,
    };
  },
  methods: {
    closeDiagMod() {
      this.showAddDiagnosis = false;
      this.fetchDiagnoses();
    },
    async get_patient_id_from_visit() {
      var body = {
        visit_id: this.visit_id,
      };
      const res = await generalApiRequest(
        "get_patient_id_from_visit",
        "GET",
        body,
        1
      );

      this.patient_id = res.data;
      console.log(res);
    },
    showAddDiagnosisModal() {
      this.showAddDiagnosis = true;
    },

    async fetchDiagnoses() {
      try {
        const res = await generalApiRequest(
          "get_diagnoses_for_visit",
          "GET",
          {
            visit_id: this.visit_id,
          },
          1
        );

        this.diagnoses = res.data;
        console.log(res);
      } catch (error) {
        console.error("Failed fetching diagnoses:", error);
      }
    },

    async deleteDiagnosis(id) {
      if (!confirm("Are you sure you want to delete this diagnosis?")) return;
      try {
        const res = await generalApiRequest(
          `delete_diagnosis/${id}`,
          "GET",
          {},
          1
        );
        if (res.status === "success") this.fetchDiagnoses();
      } catch (error) {
        console.error("Failed deleting diagnosis:", error);
      }
    },

    viewDiagnosis(diagnosis) {
      alert(
        `Diagnosis: ${diagnosis.diagnosis}\nType: ${diagnosis.diagnosis_type}\nStage: ${diagnosis.diagnosis_stage}`
      );
    },

    async mountVisitInfo() {
      const res = await generalApiRequest(
        "get_all_visits_dates",
        "GET",
        { visit_id: this.visit_id },
        1
      );
      if (res.data.length > 0) this.patient_id = res.data[0].patient_id;
    },
    getStatusClass(status) {
      return {
        Provisional: "status-provisional",
        Confirmed: "status-confirmed",
        Chronic: "status-chronic",
        "Ruled Out": "status-ruledout",
      }[status];
    },
  },
  mounted() {
    this.get_patient_id_from_visit();
    this.mountVisitInfo();
    this.fetchDiagnoses();
  },
};
</script>

<style scoped>
/* Card */
.diagnoses-card {
  margin-top: 20px;
  border-radius: 10px;
  border: 1px solid #dee2e6;
}

/* Header */
.diagnoses-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #f8f9fa, #eef1f4);
  padding: 18px 22px;
  border-bottom: 1px solid #dee2e6;
}

.diagnoses-header h3 {
  margin: 0;
  font-size: 20px;
  color: #343a40;
}

/* Table */
.diagnoses-table {
  font-size: 0.95rem;
}

.diagnoses-table thead th {
  background: #f1f3f5;
  font-weight: 600;
  color: #495057;
  border-bottom: 2px solid #dee2e6;
}

.diagnoses-table tbody tr {
  transition: background 0.2s ease;
}

.diagnoses-table tbody tr:hover {
  background: #f8f9fa;
}

/* Status badges */
.status-badge {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.status-provisional {
  background: #fff3cd;
  color: #856404;
}

.status-confirmed {
  background: #d4edda;
  color: #155724;
}

.status-chronic {
  background: #e7f1ff;
  color: #0d6efd;
}

.status-ruledout {
  background: #f8d7da;
  color: #721c24;
}

/* Buttons */
.btn-sm {
  padding: 4px 8px;
}

/* Responsive */
@media (max-width: 768px) {
  .diagnoses-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}
</style>
